import { AxiosRequestConfig } from 'axios';
import API from '../API';
import CustomerMifidCategory from '../../models/CustomerMifidCategory';

export const getCategorisationForCustomer = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
) => API.makeGetRequest(
  `/mifid/categorisation`, queryParams, options,
) as Promise<CustomerMifidCategory[]>;

export const saveCategorisation = (
  body: Partial<CustomerMifidCategory>,
  options: AxiosRequestConfig = {},
) => API.makePatchRequest(`/mifid/categorisation`, body, {}, options);

export const deleteCategorisation = (pathParams: { categorisationId: number }) =>
  API.makeDeleteRequest(`/mifid/categorisation/${pathParams.categorisationId}`, {});
